declare global {
  interface Window {
    Intercom: any;
  }
}

export const setIntercomAlignment = (alignment: 'left' | 'right') => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('update', {alignment});
  }
};

/**
 * Opens the messenger with `message` prefilled as an unsent draft. No-ops wherever Intercom never
 * boots (narrow viewports, blockers), so keep a non-chat contact route beside any trigger.
 */
export const showIntercomNewMessage = (message: string) => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showNewMessage', message);
  }
};
